/* eslint-disable unicorn/prefer-module */
/* eslint-disable no-console */
import React from "react";
import { VentasMiListaClientes } from "../../components";
import { Header } from "../../components/Header";
import styles from "./VentasEjecutivo.module.scss";

const VentasEjecutivo = () => (
  <div className={styles.containerVentasEjecutivo}>
    <VentasMiListaClientes
      renderHeader={(filtersContent) => <Header expandChildren>{filtersContent}</Header>}
      filterStyles={styles}
    />
  </div>
);

export default VentasEjecutivo;
